import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import api from "../../api/axios";
import OverviewRegister from "./OverviewRegister";

const OverviewRegisterEdit = ({ is_superuser }) => {
  const { id: projectId } = useParams();
  const location = useLocation();

  // location.state에서 initialForm 확인 (OverviewView에서 전달된 경우)
  const formFromState = location.state?.initialForm;

  // '모름' 상태(undefined)와 로딩 분리
  const [overview, setOverview] = useState(undefined); // undefined = 아직 모름
  const [loading, setLoading] = useState(!formFromState); // state에 있으면 로딩 불필요

  const token = localStorage.getItem("access");

  useEffect(() => {
    // location.state에 initialForm이 있으면 API 호출 불필요
    if (formFromState) {
      setOverview(formFromState);
      setLoading(false);
      return;
    }

    let mounted = true;

    // 프로젝트/토큰이 없으면 즉시 종료
    if (!projectId || !token) {
      setOverview(null);
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const res = await api.get(`project/${projectId}/overview/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!mounted) return;
        // 래핑된 overview 내부만 폼에 사용
        setOverview(res.data?.overview || null);
      } catch (e) {
        if (!mounted) return;
        setOverview(null);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [projectId, token, formFromState]);

  if (loading) {
    return (
      <div className="w-full min-w-0 overflow-x-hidden flex justify-center mb-16 px-4 box-border">
        <div className="w-full max-w-md min-w-0">
          <div className="p-6 text-slate-500 text-center">로딩 중...</div>
        </div>
      </div>
    );
  }

  // 로딩이 끝나면 편집 폼 렌더(overview가 null이면 빈 폼으로 열림)
  // formFromState가 있으면 우선 사용, 없으면 API에서 가져온 overview 사용
  return (
    <OverviewRegister
      is_superuser={is_superuser}
      initialForm={formFromState || overview}
      readonly={false}
    />
  );
};

export default OverviewRegisterEdit;
